import {type RouteLocationStringParam} from 'vue-router';

const FinanceIndex         = () => import('../views/finance/FinanceIndex.vue');
const FinanceView          = () => import('../views/finance/FinanceView.vue');
const FinanceList          = () => import('../views/finance/FinanceList.vue');
const FinanceEdit          = () => import('../views/finance/FinanceEdit.vue');
const StatisticAccountList = () => import('../views/finance/StatisticAccountList.vue');
const StatisticAccountView = () => import('../views/finance/StatisticAccountView.vue');
const AccountList          = () => import('../views/finance/AccountList.vue');
const AccountEdit          = () => import('../views/finance/AccountEdit.vue');
const InvoiceRecipientEdit = () => import('../views/finance/InvoiceRecipientEdit.vue');
const InvoiceRecipientList = () => import('../views/finance/InvoiceRecipientList.vue');
const InvoiceRecipientView = () => import('../views/finance/InvoiceRecipientView.vue');

let financeMeta = {
    layout: 'enhanced',
    module: 'finance',
};

let finance = [
    {
        name: 'finance',
        path: '/finance',
        redirect: {name: 'finance-index'},
        meta: financeMeta,
    },
    {
        name: 'finance-index',
        path: '/finance/index',
        component: FinanceIndex,
        meta: financeMeta,
    },
    {
        name: 'finance-list',
        path: '/finance/list',
        component: FinanceList,
        meta: financeMeta,
    },
    {
        name: 'finance-view',
        path: '/finance/view/:id',
        component: FinanceView,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'finance-add',
        path: '/finance/add',
        component: FinanceEdit,
        meta: financeMeta,
        props: {id: 0},
    },
    {
        name: 'finance-edit',
        path: '/finance/edit/:id',
        component: FinanceEdit,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'finance-copy',
        path: '/finance/copy/:copyId',
        component: FinanceEdit,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyId: parseInt(route.params.copyId),
            };
        },
    },
    {
        name: 'account-list',
        path: '/finance/account/list',
        component: AccountList,
        meta: financeMeta,
    },
    {
        name: 'account-add',
        path: '/finance/account/add',
        component: AccountEdit,
        meta: financeMeta,
        props: {id: 0},
    },
    {
        name: 'account-edit',
        path: '/finance/account/edit/:id',
        component: AccountEdit,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'account-copy',
        path: '/finance/account/copy/:copyId',
        component: AccountEdit,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyId: parseInt(route.params.copyId),
            };
        },
    },
    {
        name: 'invoice-recipient-list',
        path: '/finance/invoice-recipient/list',
        component: InvoiceRecipientList,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'invoice-recipient-view',
        path: '/finance/invoice-recipient/view/:id',
        component: InvoiceRecipientView,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'invoice-recipient-add',
        path: '/finance/invoice-recipient/add',
        component: InvoiceRecipientEdit,
        meta: financeMeta,
        props: {id: 0},
    },
    {
        name: 'invoice-recipient-edit',
        path: '/finance/invoice-recipient/edit/:id',
        component: InvoiceRecipientEdit,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'invoice-recipient-copy',
        path: '/finance/invoice-recipient/copy/:copyId',
        component: InvoiceRecipientEdit,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyId: parseInt(route.params.copyId),
            };
        },
    },
    {
        name: 'statistic-account-list',
        path: '/finance/statistic/list',
        component: StatisticAccountList,
        meta: financeMeta,
    },
    {
        name: 'statistic-account-list-monthly-evaluation',
        path: '/finance/statistic/list/monthly-evaluation',
        component: StatisticAccountList,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                monthlyEvaluation: true,
            };
        },
    },
    {
        name: 'statistic-account-view-account',
        path: '/finance/statistic/view/id/:id',
        component: StatisticAccountView,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'statistic-account-view-creditor',
        path: '/finance/statistic/view/creditorId/:creditorId',
        component: StatisticAccountView,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                creditorId: parseInt(route.params.creditorId) || 0,
            };
        },
    },
    {
        name: 'statistic-account-view-creditor-custom',
        path: '/finance/statistic/view/creditorCustom/:creditorCustom',
        component: StatisticAccountView,
        meta: financeMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                creditorCustom: route.params.creditorCustom || '',
            };
        },
    },
];

export default finance;